<p-button icon="pi pi-refresh" size="small" (onClick)="refreshData()" [rounded]="true" severity="info"
    class="refresh-button"></p-button>

<p-table #dt1 [value]="inventory" responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm "
    selectionMode="single" [paginator]="true" [rows]="5">
    <ng-template pTemplate="header">
        <tr>
            <!-- <th><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th> -->
            <th>{{unitLabel}} No </th>
            <th>QOH</th>
            <th>Q-Avail</th>
            <th>Q-Order</th>
            <th>Q-BO</th>
            <th>Q-Quote</th>
            <th>Q-Ship</th>
            <th>Q-PO</th>
            <th>Q-Def</th>
            <th>Q-Rejected</th>
            <th>Q-Process</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr>
            <!-- <td>
                <p-tableCheckbox [value]="user"></p-tableCheckbox>
             </td> -->
            <td>{{data.warehouse.warehouseCode}}</td>
            <td>{{data.quantityOnHand.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityAvailable.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityInOrder.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityInBackorder.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityInQuote.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityInShipped.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityInPO.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{data.quantityDefective.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>
            <td>{{ (data.quantityRejected ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2,
                maximumFractionDigits: 2 }) }}</td>

            <td>{{data.quantityInProcess.toLocaleString('en-IN',{
                minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</td>

        </tr>
    </ng-template>
</p-table>